import styled from "styled-components";
import theme from "./theme";

const mainBlack    = theme.colors.mainBlack;
const middleGray02   = theme.colors.middleGray02;
const darkGray     = theme.colors.darkGray;
const pointYellow  = theme.colors.pointYellow;
const sideMenu     = theme.colors.sideMenu;
const lightGray01     = theme.colors.lightGray01;
const middleGray01     = theme.colors.middleGray01;

const xl           = theme.screens.xl;
const xxl          = theme.screens.xxl;

export const MainViewport = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
`;

export const MainSectionWrap = styled.div`
    margin: 0 auto;
    display: flex;
    justify-content: center;
    /* border: 20px solid #E5E7EB; */
`;

export const HeaderContainer = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    background-color: ${mainBlack};
    color: white;
    z-index: 300;

    & .header-left-box {
        display: flex;
        align-items: baseline;
        padding-left: 64px;

        & .header-logo-box {
            display: flex;
            align-items: center;

            &:hover {
                cursor: pointer;
            }
        }

        & .header-menu-icon {
            position: absolute;
            display: none;
            top: 23px;
            left: 20px;

            &:hover {
                cursor: pointer;
            }

            @media ${xxl} {
                display: block;
            }
        }
        & .header-logo-img {
            max-width: 73px;
        }
        & .header-logo-text {
            margin-left: 10px;
            font-size: 16px;
            transform: translateY(3.2px);
        }
        & .header-manual-button {
            margin: 5px 0 0 5px;
        }
    }

    & .header-right-box {
        display: flex;
        align-items: center;
        margin-right: 10px;

        & div {
            padding: 0 10px;

            &:hover {
                cursor: pointer;
            }
        }
    }
`;

export const IndicatorBox = styled.div`
    width: 266px;
    height: 70px;
    margin-right: -10px;
    border-radius: 50px;
    color: #000;
    font-weight: 600;
    overflow: hidden;
    border: 10px solid ${mainBlack};
    
    text-align: center;
    vertical-align: middle;
    line-height: 50px;
`;

export const IndicatorContainer = styled.div`
    margin-left: -25px;
    transition: all 1s ease-in-out;
`;

export const IndicatorItem = styled.div<{$progress : number}>`
    display: flex;
    align-items: center;
    width: 260px;
    height: 50px;
    background-color: ${props => props.$progress === 2 ? `${pointYellow}` : `${middleGray02}`};

    & div {
        margin-left: 10px;
        text-align: left;

        & p {
            font-size: 12px;
            line-height: 18px;
        }

        & .client-text {
            font-weight: 600;
        }
    }
`;

export const ModalNavigation = styled.div`
    position: absolute;
    left: 0;
    top: 70px;
    width: 360px;
    /* height: 845px; */
    height: 100vh;
    /* background-color: #F3F4F6; */
    z-index: 200;
    /* 스크롤 이상하면 그냥 밑에 두개를 100% +a로 잡던가 해야함 */
    overflow-y: scroll;
`;

export const ModalBackground = styled.div`
    position: absolute;
    overflow-y: hidden;
    width: 100%;
    min-height: 100vh;
    /* background: rgba(0,0,0,0.5); */
    z-index: 199;
`;

/* margin-top: 70px; */
/* margin-top: ${props => props.$positionY+70}px; */
interface NavigationAreaProps {
    $positionY: number;
};
// attrs를 사용하면 클래스를 계속 생성해서 사용하는게 아니라 inline 속성으로 적용해서 메모리를 아낄 수 있다고 한다
export const NavigationArea = styled.div.attrs<NavigationAreaProps>(props => ({
    // style : {
    //     transform : `translateY(${props.$positionY}px)`
    // }
}))<NavigationAreaProps>`
    margin-top : 70px;
    background-color: ${sideMenu};
    width: 360px;
    /* FIXME: 이거 나중에 계산해서 100vh-70px 하던지 해야함*/
    /* height: 900px; */
    height: 100vh;
    transition: all 0.4s ease-out;

    @media ${xxl} {
        margin-top: 0;
        height: 100vh;
        min-height: 950px;
    }
    /* height: 1000px; */
`;

export const CustomerInfoBox = styled.div`
    width: 360px;
    height: 257px;
    background-color: ${mainBlack};
    border-top: 0.5px solid ${middleGray02};

    & .customer-account-box {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        margin: 42px auto;

        & .customer-name {
            font-size: 24px;
            font-weight: 500;
            color: #F9FAFB;
        }

        & .nim {
            font-size: 16px;
            color: #F9FAFB;
        }

        & p {
            font-size: 14px;
            line-height: 20px;
            color: #6B7280;
        }

        & .logout-btn {
            width: 80px;
            height: 30px;   
            flex-shrink: 0;
            border-radius: 30px;
            border: 1px solid ${mainBlack};
            background: ${darkGray};
            color: ${lightGray01};
            font-size: 14px;
            line-height: 20px;
            text-align: center;

            &:hover {
                border-color: #fff;
                color: #fff;
            }
        }
    }

    & .customer-point-box {
        display: block;
        width: 360px;


        & div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 320px;
            height: 50px;
            padding: 0 13px;
            margin: 10px auto;
            background-color: ${sideMenu};
            border-radius: 5px;

            & .customer-point-name {
                color: ${middleGray01};
            }

            & .customer-point-value {
                color: ${mainBlack};
                font-weight: 600;
            }
        }
    }
`;

export const UsageSummary = styled.div<{$width:number}>`
    display: grid;
    position: relative;
    grid-template-columns: repeat(4, 1fr);
    padding: 20px 20px;
    width: ${props => props.$width}px;
    background-color: #fff;
    cursor: pointer;

    & .usage-items {
        text-align: center;
        position: relative;
        font-size: 14px;
        z-index: 1;

        &::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 80%;
            border-right: 0.5px solid ${middleGray02};
        }

        &:nth-child(1)::before {
            border-right: 0;
        }

        & .usage-icon-box {
            display: flex;
            justify-content: center;
            margin-bottom: 12px;
        }

        & p {
            line-height: 23px;
        }

        & span {
            line-height: 23px;
            font-size: 16px;
            font-weight: 600;
        }

        & h6 {
            line-height: 28px;
            font-size: 20px;
            font-weight: 600;
        }
    }
`;

export const HorizontalBar = styled.div`
    width: 360px;
    padding: 0 20px;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 0;
        width: 320px;
        height: 1px;
        border-bottom: 0.5px solid ${middleGray02};
    }
`;

export const NavLinkBox = styled.div`
    width: 360px;
    padding: 0 20px;
    margin-bottom: 10px;
    font-size: 14px;
    background-color: #fff;
    
    & div {
        display: flex;
        align-items: center;
        height: 40px;
        border-bottom: 0.5px solid ${middleGray02};

        &:nth-last-child(1) {
            border-bottom: 0;
        }

        & button:hover {
            font-weight: 600;
        }
    }
`;

export const FooterContainer = styled.div`
    display: flex;
    background-color: #E5E7EB;

    /* @media ${xl} {
        padding-top: 20px;
    } */

    & .fake-box {
        width: 360px;
        background-color: ${sideMenu};
        color: ${middleGray01};
    }

    & .real-box {
        padding-left: 20px;

        & .button-area {
            font-size: 12px;
        }

        & .corp-info-box {
            margin-top: 15px;
            font-size: 10px;
            line-height: 150%;
        }

        & .copyright-box {
            margin-top: 15px;
            margin-bottom: 27px;
            font-size: 10px;
        }
    }
`;